import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { replaceqbix900hl8kl as replace } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { Decoder2ddeqv6fq19z5 as Decoder } from './Decoder.js.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  readByteArray1fhzfwi2j014k as readByteArray,
  readByteArray1ri21h2rciakw as readByteArray_0,
} from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { encodeISO88591v742do8ms7fc as encodeISO88591 } from './ISO88591.mjs';
import {
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { encodeToImpl35qnqj6vvbsjt as encodeToImpl } from './Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      u4q(name) {
        switch (name) {
          case 'UTF-8':
          case 'utf-8':
          case 'UTF8':
          case 'utf8':
            return Charsets_getInstance().d4q_1;
        }
        var tmp;
        var tmp_0;
        switch (name) {
          case 'ISO-8859-1':
          case 'iso-8859-1':
            tmp_0 = true;
            break;
          default:
            // Inline function 'kotlin.let' call

            var it = replace(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
            var tmp_1;
            if (it === 'iso-8859-1') {
              tmp_1 = true;
            } else {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp_1 = it.toLowerCase() === 'iso-8859-1';
            }

            tmp_0 = tmp_1;
            break;
        }
        if (tmp_0) {
          tmp = true;
        } else {
          tmp = name === 'latin1' || name === 'Latin1';
        }
        if (tmp) {
          return Charsets_getInstance().e4q_1;
        }
        throw IllegalArgumentException().n2('Charset ' + name + ' is not supported');
      }
      v4q(charset) {
        var tmp;
        switch (charset) {
          case 'UTF-8':
          case 'utf-8':
          case 'UTF8':
          case 'utf8':
            tmp = true;
            break;
          default:
            var tmp_0;
            var tmp_1;
            switch (charset) {
              case 'ISO-8859-1':
              case 'iso-8859-1':
                tmp_1 = true;
                break;
              default:
                // Inline function 'kotlin.let' call

                var it = replace(charset, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
                var tmp_2;
                if (it === 'iso-8859-1') {
                  tmp_2 = true;
                } else {
                  // Inline function 'kotlin.text.lowercase' call
                  // Inline function 'kotlin.js.asDynamic' call
                  tmp_2 = it.toLowerCase() === 'iso-8859-1';
                }

                tmp_1 = tmp_2;
                break;
            }

            if (tmp_1) {
              tmp_0 = true;
            } else {
              tmp_0 = charset === 'latin1';
            }

            if (tmp_0) {
              tmp = true;
            } else {
              tmp = false;
            }

            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CharsetClass;
function Charset() {
  if (CharsetClass === VOID) {
    class $ {
      constructor(_name) {
        this.f4q_1 = _name;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !(this.constructor == other.constructor))
          return false;
        if (!(other instanceof Charset()))
          THROW_CCE();
        return this.f4q_1 === other.f4q_1;
      }
      hashCode() {
        return getStringHashCode(this.f4q_1);
      }
      toString() {
        return this.f4q_1;
      }
    }
    initMetadataForClass($, 'Charset');
    CharsetClass = $;
  }
  return CharsetClass;
}
var CharsetsClass;
function Charsets() {
  if (CharsetsClass === VOID) {
    class $ {
      constructor() {
        Charsets_instance = this;
        this.d4q_1 = new (CharsetImpl())('UTF-8');
        this.e4q_1 = new (CharsetImpl())('ISO-8859-1');
      }
    }
    initMetadataForObject($, 'Charsets');
    CharsetsClass = $;
  }
  return CharsetsClass;
}
var Charsets_instance;
function Charsets_getInstance() {
  if (Charsets_instance === VOID)
    new (Charsets())();
  return Charsets_instance;
}
var CharsetDecoderClass;
function CharsetDecoder() {
  if (CharsetDecoderClass === VOID) {
    class $ {
      constructor(_charset) {
        this.w4q_1 = _charset;
      }
    }
    initMetadataForClass($, 'CharsetDecoder');
    CharsetDecoderClass = $;
  }
  return CharsetDecoderClass;
}
var MalformedInputExceptionClass;
function MalformedInputException() {
  if (MalformedInputExceptionClass === VOID) {
    class $ extends IOException() {
      static c4q(message) {
        var $this = this.f4m(message);
        captureStack($this, $this.b4q_1);
        return $this;
      }
    }
    initMetadataForClass($, 'MalformedInputException');
    MalformedInputExceptionClass = $;
  }
  return MalformedInputExceptionClass;
}
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.f4q_1;
}
function isSupported(_this__u8e3s4, name) {
  return Companion_instance.v4q(name);
}
function forName(_this__u8e3s4, name) {
  return Companion_instance.u4q(name);
}
var CharsetEncoderClass;
function CharsetEncoder() {
  if (CharsetEncoderClass === VOID) {
    class $ {
      constructor(_charset) {
        this.x4q_1 = _charset;
      }
    }
    initMetadataForClass($, 'CharsetEncoder');
    CharsetEncoderClass = $;
  }
  return CharsetEncoderClass;
}
function decode(_this__u8e3s4, input, dst, max) {
  var decoder = Decoder(get_name(get_charset(_this__u8e3s4)), true);
  var tmp0 = input.u3z().q2();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = fromInt(max);
  var count = tmp0 <= b ? tmp0 : b;
  var array = readByteArray(input, convertToInt(count));
  var tmp;
  try {
    // Inline function 'org.khronos.webgl.toInt8Array' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = decoder.y4q(array);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var cause = $p;
      var tmp0_elvis_lhs = cause.message;
      throw MalformedInputException().c4q('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
    } else {
      throw $p;
    }
  }
  var result = tmp;
  dst.o2(result);
  return result.length;
}
function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(fromIndex <= toIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().n2(toString(message));
  }
  if (get_charset_0(_this__u8e3s4).equals(Charsets_getInstance().e4q_1)) {
    return encodeISO88591(input, fromIndex, toIndex, dst);
  }
  // Inline function 'kotlin.require' call
  if (!(get_charset_0(_this__u8e3s4) === Charsets_getInstance().d4q_1)) {
    var message_0 = 'Only UTF-8 encoding is supported in JS';
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var encoder = new TextEncoder();
  // Inline function 'kotlin.text.substring' call
  var tmp$ret$5 = toString(charSequenceSubSequence(input, fromIndex, toIndex));
  var result = encoder.encode(tmp$ret$5);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  dst.p4k(result);
  return result.length;
}
function encodeToByteArray(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  return encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex);
}
var CharsetImplClass;
function CharsetImpl() {
  if (CharsetImplClass === VOID) {
    class $ extends Charset() {
      h4q() {
        return new (CharsetEncoderImpl())(this);
      }
      g4q() {
        return new (CharsetDecoderImpl())(this);
      }
    }
    initMetadataForClass($, 'CharsetImpl');
    CharsetImplClass = $;
  }
  return CharsetImplClass;
}
function get_charset(_this__u8e3s4) {
  return _this__u8e3s4.w4q_1;
}
function get_charset_0(_this__u8e3s4) {
  return _this__u8e3s4.x4q_1;
}
function encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  var start = fromIndex;
  if (start >= toIndex)
    return new Int8Array(0);
  var dst = new (Buffer())();
  var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, dst);
  start = start + rc | 0;
  if (start === toIndex) {
    return readByteArray_0(dst);
  }
  encodeToImpl(_this__u8e3s4, dst, input, start, toIndex);
  return readByteArray_0(dst);
}
var CharsetEncoderImplClass;
function CharsetEncoderImpl() {
  if (CharsetEncoderImplClass === VOID) {
    class $ extends CharsetEncoder() {
      constructor(charset) {
        super(charset);
        this.b4r_1 = charset;
      }
      toString() {
        return 'CharsetEncoderImpl(charset=' + this.b4r_1.toString() + ')';
      }
      hashCode() {
        return this.b4r_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CharsetEncoderImpl()))
          return false;
        if (!this.b4r_1.equals(other.b4r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CharsetEncoderImpl');
    CharsetEncoderImplClass = $;
  }
  return CharsetEncoderImplClass;
}
var CharsetDecoderImplClass;
function CharsetDecoderImpl() {
  if (CharsetDecoderImplClass === VOID) {
    class $ extends CharsetDecoder() {
      constructor(charset) {
        super(charset);
        this.d4r_1 = charset;
      }
      toString() {
        return 'CharsetDecoderImpl(charset=' + this.d4r_1.toString() + ')';
      }
      hashCode() {
        return this.d4r_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CharsetDecoderImpl()))
          return false;
        if (!this.d4r_1.equals(other.d4r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CharsetDecoderImpl');
    CharsetDecoderImplClass = $;
  }
  return CharsetDecoderImplClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Charsets_getInstance as Charsets_getInstanceqkyjyusuh1b0,
  MalformedInputException as MalformedInputExceptionbvc6h5ij0ias,
  decode as decode3smkguvhgu00o,
  encodeImpl as encodeImpl2q4xw7zvyejjm,
  encodeToByteArray as encodeToByteArrayomtvgs5lyogm,
  forName as forName2faodmskqnoz5,
  isSupported as isSupported2nf870ypy50et,
  get_name as get_name2f11g4r0d5pxp,
};
//endregion

//# sourceMappingURL=Charset.js.mjs.map
